import { stringify } from 'qs';
import { BooleanParam, encodeQueryParams, JsonParam, StringParam } from 'use-query-params';
import { CompressedJsonParam } from 'utils/customQueryParamsConfigs';

import { getDefaultManifestDialogUrlState, ManifestSurface, ManifestSurfaceParam } from './dialogState';
import type { ManifestDestination } from './loadManifestDestination';
import type { ManifestWorkbookContext } from './manifestWorkbookContext';

export interface ManifestDestinationNavigationState {
  manifestDestination?: {
    file?: File;
    context: ManifestWorkbookContext;
    destination: ManifestDestination;
    original: { url: string; labId: string; studyId: string; state?: unknown };
  };
}

export const getManifestDialogUrl = ({
  studyId,
  labId,
  manifestState,
  manifestSurface = 'Manifest',
}: {
  studyId: string;
  labId: string;
  manifestState: ReturnType<typeof getDefaultManifestDialogUrlState>;
  // null omits the surface so the dialog opens on the entry choices.
  manifestSurface?: ManifestSurface | null;
}) => {
  const encodedQuery = encodeQueryParams(
    {
      filters: JsonParam,
      labId: StringParam,
      isManifestDialogOpen: BooleanParam,
      slidesMode: BooleanParam,
      manifestSurface: ManifestSurfaceParam,
      caseManifestState: CompressedJsonParam,
    },
    {
      filters: { studyId },
      labId,
      isManifestDialogOpen: true,
      slidesMode: true,
      manifestSurface: manifestSurface ?? undefined,
      caseManifestState: manifestState,
    }
  );

  return `/procedures?${stringify({ ...encodedQuery })}`;
};
